import {z} from 'zod';

export enum SharedResourceModeFilter {
	READ = 'read',
	WRITE = 'write',
	DELETE = 'delete',
	FAVORITES = 'favorites',
}

export enum SharedResourceName {
	SAVED_CART = 'savedCart',
	SAVED_SEARCH = 'savedSearch',
	ATTRIBUTE_SET = 'attributeSet',
	// ATTRIBUTE = 'attribute',
	PROJECT = 'project',
}

export const SharedResourceSchema = z.object({
	id: z.number().int().gt(0),
	canEdit: z.boolean(),
	canManage: z.boolean(),
	contentCount: z.number().int().positive(),
	isFavorite: z.boolean(),
	participantCount: z.number().int().positive(),
	title: z.string(),
});
export default SharedResourceSchema;

export const SharedResourcesSchema = z.array(SharedResourceSchema);

export type SharedResource = z.infer<typeof SharedResourceSchema>;

export const SharedResourceField = SharedResourceSchema.keyof().enum;

export type ISharedResource = z.infer<typeof SharedResourceSchema>;
